import { __decorate } from "tslib";
import { TaskStatus, NodeType } from '../../Types/TaskStatus';
import { BindingHelper } from '../NodeExecutor';
import { NodeExecutorMetadata } from '../NodeMetadata';
/**
 * 执行条件执行器
 *
 * 执行自定义条件逻辑
 */
let ExecuteCondition = class ExecuteCondition {
    execute(context) {
        const { runtime, entity } = context;
        const conditionName = BindingHelper.getValue(context, 'conditionName', '');
        if (!conditionName) {
            return TaskStatus.Failure;
        }
        const conditionFunction = runtime.getBlackboardValue(`condition_${conditionName}`);
        if (!conditionFunction || typeof conditionFunction !== 'function') {
            return TaskStatus.Failure;
        }
        try {
            return conditionFunction(entity) ? TaskStatus.Success : TaskStatus.Failure;
        }
        catch (error) {
            console.error(`ExecuteCondition failed: ${error}`);
            return TaskStatus.Failure;
        }
    }
};
ExecuteCondition = __decorate([
    NodeExecutorMetadata({
        implementationType: 'ExecuteCondition',
        nodeType: NodeType.Condition,
        displayName: '执行条件',
        description: '执行自定义条件逻辑',
        category: 'Condition',
        configSchema: {
            conditionName: {
                type: 'string',
                default: '',
                description: '条件名称（黑板中condition_前缀的函数）'
            }
        }
    })
], ExecuteCondition);
export { ExecuteCondition };
//# sourceMappingURL=ExecuteCondition.js.map